export default "__VITE_ASSET__DUJO6b5Z__"